<app-dialog-header title="Ticket Audit Viewer (ID {{ data.ticketId }})" (closeClicked)="onCloseClick()">
</app-dialog-header>

<mat-dialog-content class="fullscreen-dialog" style="padding-top: 10px; height: 800px; position: relative;">
  <ngx-ui-loader [loaderId]="'audit-loader'"></ngx-ui-loader>

  <div
    style="padding: 24px 24px 24px 24px; display: flex; align-items: center; border-bottom: 1px solid #e0e0e0; margin-bottom: 10px;">
    <mat-checkbox (change)="onIncludeSystemChange($event, auditGrid)" color="primary">Include System</mat-checkbox>
  </div>

  <div style="padding: 0 24px;">
    <app-grid #auditGrid [autoHeight]=true [cellEdit]="false" [columns]="auditColumns" [filter]="true"
      [rowExpander]="rowExpanderConfig" [showRemoveRowInContextMenu]="false" [width]="'100%'"></app-grid>
  </div>

</mat-dialog-content>
